import React from 'react';
import './App.css';
import Form from './components/Form';
import JsonConsole from './components/JsonConsole';
import Offerwall from './components/Offerwall';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import { Button } from '@material-ui/core';
import { RequestJSON } from './@types/requestJson/RequestJSON';
import { ResponseJSON } from './@types/responseJson/ResponseJSON';

type MyState = {
  requestJSON: RequestJSON,
  responseJSON: ResponseJSON,
  step1responseJSON: ResponseJSON,
  step2responseJSON: ResponseJSON,
  toggleOffers: boolean,
  pendingOffers: boolean,
  pendingStep: number
}

class App extends React.Component<{}, MyState>{
  constructor(props: {}){
    super(props);
    this.state = {
      requestJSON: {
        productTypes: [
          "loan"
        ],
        personalInformation: {
          firstName: "",
          lastName: "",
          email: "",
          city: "",
          state: " ",
          primaryPhone: "1234567890",
          address1: "",
          address2: "",
          zipcode: "",
          dateOfBirth: "1993-10-09",
          ssn: "123-45-6789"
        },
        loanInformation: {
          purpose: "debt_consolidation",
          loanAmount: 5000
        },
        mortgageInformation: {
          propertyStatus: " "
        },
        creditInformation: {
          providedCreditRating: " "
        },
        financialInformation: {
          employmentStatus: " ",
          employmentPayFrequency: " ",
          annualIncome: 0
        },
        educationInformation: {
          educationLevel: " "
        },
        legalInformation: {
          consentsToFcra: false,
          consentsToTcpa: false,
          tcpaLanguage: "I agree to be contacted by Even Financial and its partners at the telephone number(s) I have provided above to explore personal loan offers, including contact through automatic dialing systems, artificial or pre-recorded voice messaging, or text message. I understand my consent is not required as a condition to purchasing any goods or services from anyone."
        }
      },
      responseJSON: {
        uuid: "11111111-1111-1111-1111-111111111111",
        leadUuid: "22222222-2222-2222-2222-222222222222",
        loanAmount: 10000,
        creditCardOffers: [],
        loanOffers: [
            {
                minAmount: 1000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: null,
                payout: 3.01,
                minMonthlyPayment: 307.82,
                originator: {
                    key: "lending-club",
                    name: "LendingClub",
                    description: "<span> <ul> <li>Low fixed rate personal loans from $1,000 to $40,000</li> <li> Simple and secure- check your rate without hurting your credit score</li> <li>Fast, Simple, Secure- know your loan decision within minutes</li> </span><span><li> No Hidden Fees, No Prepayment Penalties</li> </ul> </span>",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/lendingclub/lendingclub_120.png"
                        }
                    ],
                    disclaimer: "All loans made by WebBank, Member FDIC. Your actual rate depends upon credit score, loan amount, loan term, and credit usage & history. The APR ranges from 6.95% to 35.89%*. The origination fee ranges from 1% to 6% of the original principal balance and is deducted from your loan proceeds. For example, you could receive a loan of $6,000 with an interest rate of 7.99% and a 5.00% origination fee of $300 for an APR of 11.51%. In this example, you will receive $5,700 and will make 36 monthly payments of $187.99. The total amount repayable will be $6,767.64. Your APR will be determined based on your credit at the time of application. The average origination fee is 5.2% (as of 12/5/18 YTD). In Georgia, the minimum loan amount is $3,025. In Massachusetts, the minimum loan amount is $6,025 if your APR is greater than 12%. There is no down payment and there is never a prepayment penalty. Closing of your loan is contingent upon your agreement of all the required agreements and disclosures on the www.lendingclub.com website. All loans via LendingClub have a minimum repayment term of 36 months. Borrower must be a U.S. citizen, permanent resident or be in the United States on a valid long term visa and at least 18 years old. Valid bank account and Social Security number are required. Equal Housing Lender. All loans are subject to credit approval. LendingClub’s physical address is: LendingClub, 71 Stevenson Street, Suite 1000, San Francisco, CA 94105.",
                    companyUuid: "00000000-0000-0000-0000-000000000000"
                },
                minApr: 6.79,
                uuid: "33333333-3333-3333-3333-333333333333",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 6.79,
                monthlyPayment: 307.82,
                terms: null,
                recommendationScore: 301,
                maxMonthlyPayment: 307.82,
                originatorId: null,
                maxAmount: 40000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.lendingclub.com/",
                meanApr: 6.79,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 36,
                meanTotalPayment: 11082,
                preApproved: false,
                minTotalPayment: 11082,
                maxTotalPayment: 11082,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 307.82
            },
            {
                minAmount: 5000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: null,
                payout: 0.1,
                minMonthlyPayment: 203.73,
                originator: {
                    key: "so-fi",
                    name: "SoFi",
                    description: "No late or insufficient funds fees, no origination fees, and no prepayment penalties.",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/sofi/sofi_120.png"
                        }
                    ],
                    disclaimer: "Fixed rates from 5.99% APR to 16.99% APR (with AutoPay). Variable rates from 5.74% APR to 14.70% APR (with AutoPay). SoFi rate ranges are current as of March 18, 2019 and are subject to change without notice. Not all rates and amounts available in all states. See <a href='https://www.sofi.com/eligibility-criteria#eligibility-personal' target='_blank'>Personal Loan eligibility details</a>. Not all applicants qualify for the lowest rate. If approved for a loan, to qualify for the lowest rate, you must have a responsible financial history and meet other conditions. Your actual rate will be within the range of rates listed above and will depend on a variety of factors, including evaluation of your credit worthiness, years of professional experience, income and other factors. See <a href='https://www.sofi.com/personal-loans/personal-loan-rates/' target='_blank'>APR examples and terms</a>. Interest rates on variable rate loans are capped at 14.95%. Lowest variable rate of 5.74% APR assumes current 1-month LIBOR rate of 2.49% plus 4.28% margin minus 0.25% AutoPay discount. For the SoFi variable rate loan, the 1-month LIBOR index will adjust monthly and the loan payment will be re-amortized and may change monthly. APRs for variable rate loans may increase after origination if the LIBOR index increases. The SoFi 0.25% AutoPay interest rate reduction requires you to agree to make monthly principal and interest payments by an automatic monthly deduction from a savings or checking account. The benefit will discontinue and be lost for periods in which you do not pay by automatic deduction from a savings or checking account.",
                    companyUuid: "66666666-6666-6666-6666-666666666666"
                },
                minApr: 8.2,
                uuid: "44444444-4444-4444-4444-444444444444",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 17.67,
                monthlyPayment: 203.73,
                terms: null,
                recommendationScore: 10,
                maxMonthlyPayment: 252.15,
                originatorId: null,
                maxAmount: 100000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.sofi.com/homepage/",
                meanApr: 12.935,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 60,
                meanTotalPayment: 13632,
                preApproved: false,
                minTotalPayment: 12224,
                maxTotalPayment: 15129,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 227.2
            },
            {
                minAmount: 1000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: 0,
                payout: 0.1,
                minMonthlyPayment: 313.28,
                originator: {
                    key: "upgrade",
                    name: "Upgrade",
                    description: "All loans through Upgrade feature fast funding, low fixed rates that will never increase, and an easy online interface to manage your loan.",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png"
                        }
                    ],
                    disclaimer: "Personal loans made through Upgrade feature APRs of 6.98%-35.89%. All personal loans have a 1.5% to 6% origination fee, which is deducted from the loan proceeds. Lowest rates require Autopay and paying off a portion of existing debt directly. For example, if you receive a $10,000 loan with a 36-month term and a 17.98% APR (which includes a 14.32% yearly interest rate and a 5% one-time origination fee), you would receive $9,500 in your account and would have a required monthly payment of $343.33. Over the life of the loan, your payments would total $12,359.97. The APR on your loan may be higher or lower and your loan offers may not have multiple term lengths available. Actual rate depends on credit score, credit usage history, loan term, and other factors. Late payments or subsequent charges and fees may increase the cost of your fixed rate loan. There is no fee or penalty for repaying a loan early. Personal loans issued by Upgrade's lending partners. Information on Upgrade's lending partners can be found at https://www.upgrade.com/lending-partners/.  ",
                    companyUuid: "77777777-7777-7777-7777-777777777777"
                },
                minApr: 7.98,
                uuid: "55555555-5555-5555-5555-555555555555",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 7.98,
                monthlyPayment: 313.28,
                terms: null,
                recommendationScore: 10,
                maxMonthlyPayment: 313.28,
                originatorId: null,
                maxAmount: 50000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.upgrade.com/",
                meanApr: 7.98,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 36,
                meanTotalPayment: 11279,
                preApproved: false,
                minTotalPayment: 11279,
                maxTotalPayment: 11279,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 313.28
            }
        ],
        mortgageOffers: [],
        savingsOffers: [],
        specialOffers: [],
        pendingOriginators: [],
        pendingResponses: []
      },
      step1responseJSON: {
        uuid: "11111111-1111-1111-1111-111111111111",
        leadUuid: "22222222-2222-2222-2222-222222222222",
        loanAmount: 10000,
        creditCardOffers: [],
        loanOffers: [
            {
                minAmount: 1000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: null,
                payout: 3.01,
                minMonthlyPayment: 307.82,
                originator: {
                    key: "lending-club",
                    name: "LendingClub",
                    description: "<span> <ul> <li>Low fixed rate personal loans from $1,000 to $40,000</li> <li> Simple and secure- check your rate without hurting your credit score</li> <li>Fast, Simple, Secure- know your loan decision within minutes</li> </span><span><li> No Hidden Fees, No Prepayment Penalties</li> </ul> </span>",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/lendingclub/lendingclub_120.png"
                        }
                    ],
                    disclaimer: "All loans made by WebBank, Member FDIC. Your actual rate depends upon credit score, loan amount, loan term, and credit usage & history. The APR ranges from 6.95% to 35.89%*. The origination fee ranges from 1% to 6% of the original principal balance and is deducted from your loan proceeds. For example, you could receive a loan of $6,000 with an interest rate of 7.99% and a 5.00% origination fee of $300 for an APR of 11.51%. In this example, you will receive $5,700 and will make 36 monthly payments of $187.99. The total amount repayable will be $6,767.64. Your APR will be determined based on your credit at the time of application. The average origination fee is 5.2% (as of 12/5/18 YTD). In Georgia, the minimum loan amount is $3,025. In Massachusetts, the minimum loan amount is $6,025 if your APR is greater than 12%. There is no down payment and there is never a prepayment penalty. Closing of your loan is contingent upon your agreement of all the required agreements and disclosures on the www.lendingclub.com website. All loans via LendingClub have a minimum repayment term of 36 months. Borrower must be a U.S. citizen, permanent resident or be in the United States on a valid long term visa and at least 18 years old. Valid bank account and Social Security number are required. Equal Housing Lender. All loans are subject to credit approval. LendingClub’s physical address is: LendingClub, 71 Stevenson Street, Suite 1000, San Francisco, CA 94105.",
                    companyUuid: "00000000-0000-0000-0000-000000000000"
                },
                minApr: 6.79,
                uuid: "33333333-3333-3333-3333-333333333333",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 6.79,
                monthlyPayment: 307.82,
                terms: null,
                recommendationScore: 301,
                maxMonthlyPayment: 307.82,
                originatorId: null,
                maxAmount: 40000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.lendingclub.com/",
                meanApr: 6.79,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 36,
                meanTotalPayment: 11082,
                preApproved: false,
                minTotalPayment: 11082,
                maxTotalPayment: 11082,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 307.82
            },
        ],
        mortgageOffers: [],
        savingsOffers: [],
        specialOffers: [],
        pendingOriginators: [
          {
            key: "so-fi",
            name: "SoFi",
              images: [
                {
                    sizeKey: "120x40",
                    url: "https://aff-tag.evenfinancial.com/images/sofi/sofi_120.png"
                }
            ],
            companyUuid: "66666666-6666-6666-6666-666666666666"
          },
          {
            key: "upgrade",
            name: "Upgrade",
            images: [
                {
                    sizeKey: "120x40",
                    url: "https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png"
                }
            ],
            companyUuid: "77777777-7777-7777-7777-777777777777"
        }
        ],
        pendingResponses: [
            {
                partner: {
                  uuid: "44444444-4444-4444-4444-444444444444",
                  name: "SoFi",
                  description: "No late or insufficient funds fees, no origination fees, and no prepayment penalties.",
                  disclaimer: "Fixed rates from 5.99% APR to 16.99% APR (with AutoPay). Variable rates from 5.74% APR to 14.70% APR (with AutoPay). SoFi rate ranges are current as of March 18, 2019 and are subject to change without notice. Not all rates and amounts available in all states. See <a href='https://www.sofi.com/eligibility-criteria#eligibility-personal' target='_blank'>Personal Loan eligibility details</a>. Not all applicants qualify for the lowest rate. If approved for a loan, to qualify for the lowest rate, you must have a responsible financial history and meet other conditions. Your actual rate will be within the range of rates listed above and will depend on a variety of factors, including evaluation of your credit worthiness, years of professional experience, income and other factors. See <a href='https://www.sofi.com/personal-loans/personal-loan-rates/' target='_blank'>APR examples and terms</a>. Interest rates on variable rate loans are capped at 14.95%. Lowest variable rate of 5.74% APR assumes current 1-month LIBOR rate of 2.49% plus 4.28% margin minus 0.25% AutoPay discount. For the SoFi variable rate loan, the 1-month LIBOR index will adjust monthly and the loan payment will be re-amortized and may change monthly. APRs for variable rate loans may increase after origination if the LIBOR index increases. The SoFi 0.25% AutoPay interest rate reduction requires you to agree to make monthly principal and interest payments by an automatic monthly deduction from a savings or checking account. The benefit will discontinue and be lost for periods in which you do not pay by automatic deduction from a savings or checking account.",
                  supportsPersonalizedOffers: true,
                  supportsPreSelect: false,
                  imageUrl: "https://aff-tag.evenfinancial.com/images/sofi/sofi_120.png"
                },
                productTypes: [
                    "loan"
                ]
            },
            {
                partner: {
                  uuid: "55555555-5555-5555-5555-555555555555",
                  name: "Upgrade",
                  description: "All loans through Upgrade feature fast funding, low fixed rates that will never increase, and an easy online interface to manage your loan.",
                  disclaimer: "Personal loans made through Upgrade feature APRs of 6.98%-35.89%. All personal loans have a 1.5% to 6% origination fee, which is deducted from the loan proceeds. Lowest rates require Autopay and paying off a portion of existing debt directly. For example, if you receive a $10,000 loan with a 36-month term and a 17.98% APR (which includes a 14.32% yearly interest rate and a 5% one-time origination fee), you would receive $9,500 in your account and would have a required monthly payment of $343.33. Over the life of the loan, your payments would total $12,359.97. The APR on your loan may be higher or lower and your loan offers may not have multiple term lengths available. Actual rate depends on credit score, credit usage history, loan term, and other factors. Late payments or subsequent charges and fees may increase the cost of your fixed rate loan. There is no fee or penalty for repaying a loan early. Personal loans issued by Upgrade's lending partners. Information on Upgrade's lending partners can be found at https://www.upgrade.com/lending-partners/.  ",
                  supportsPersonalizedOffers: true,
                  supportsPreSelect: false,
                  imageUrl: "https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png"
                },
                productTypes: [
                    "loans"
                ]
            }
        ]
      },
      step2responseJSON: {
        uuid: "11111111-1111-1111-1111-111111111111",
        leadUuid: "22222222-2222-2222-2222-222222222222",
        loanAmount: 10000,
        creditCardOffers: [],
        loanOffers: [
            {
                minAmount: 1000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: null,
                payout: 3.01,
                minMonthlyPayment: 307.82,
                originator: {
                    key: "lending-club",
                    name: "LendingClub",
                    description: "<span> <ul> <li>Low fixed rate personal loans from $1,000 to $40,000</li> <li> Simple and secure- check your rate without hurting your credit score</li> <li>Fast, Simple, Secure- know your loan decision within minutes</li> </span><span><li> No Hidden Fees, No Prepayment Penalties</li> </ul> </span>",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/lendingclub/lendingclub_120.png"
                        }
                    ],
                    disclaimer: "All loans made by WebBank, Member FDIC. Your actual rate depends upon credit score, loan amount, loan term, and credit usage & history. The APR ranges from 6.95% to 35.89%*. The origination fee ranges from 1% to 6% of the original principal balance and is deducted from your loan proceeds. For example, you could receive a loan of $6,000 with an interest rate of 7.99% and a 5.00% origination fee of $300 for an APR of 11.51%. In this example, you will receive $5,700 and will make 36 monthly payments of $187.99. The total amount repayable will be $6,767.64. Your APR will be determined based on your credit at the time of application. The average origination fee is 5.2% (as of 12/5/18 YTD). In Georgia, the minimum loan amount is $3,025. In Massachusetts, the minimum loan amount is $6,025 if your APR is greater than 12%. There is no down payment and there is never a prepayment penalty. Closing of your loan is contingent upon your agreement of all the required agreements and disclosures on the www.lendingclub.com website. All loans via LendingClub have a minimum repayment term of 36 months. Borrower must be a U.S. citizen, permanent resident or be in the United States on a valid long term visa and at least 18 years old. Valid bank account and Social Security number are required. Equal Housing Lender. All loans are subject to credit approval. LendingClub’s physical address is: LendingClub, 71 Stevenson Street, Suite 1000, San Francisco, CA 94105.",
                    companyUuid: "00000000-0000-0000-0000-000000000000"
                },
                minApr: 6.79,
                uuid: "33333333-3333-3333-3333-333333333333",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 6.79,
                monthlyPayment: 307.82,
                terms: null,
                recommendationScore: 301,
                maxMonthlyPayment: 307.82,
                originatorId: null,
                maxAmount: 40000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.lendingclub.com/",
                meanApr: 6.79,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 36,
                meanTotalPayment: 11082,
                preApproved: false,
                minTotalPayment: 11082,
                maxTotalPayment: 11082,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 307.82
            },
            {
                minAmount: 5000,
                maxFeeRate: null,
                maxFeeFixed: null,
                prepaymentFee: null,
                payout: 0.1,
                minMonthlyPayment: 203.73,
                originator: {
                    key: "so-fi",
                    name: "SoFi",
                    description: "No late or insufficient funds fees, no origination fees, and no prepayment penalties.",
                    images: [
                        {
                            sizeKey: "120x40",
                            url: "https://aff-tag.evenfinancial.com/images/sofi/sofi_120.png"
                        }
                    ],
                    disclaimer: "Fixed rates from 5.99% APR to 16.99% APR (with AutoPay). Variable rates from 5.74% APR to 14.70% APR (with AutoPay). SoFi rate ranges are current as of March 18, 2019 and are subject to change without notice. Not all rates and amounts available in all states. See <a href='https://www.sofi.com/eligibility-criteria#eligibility-personal' target='_blank'>Personal Loan eligibility details</a>. Not all applicants qualify for the lowest rate. If approved for a loan, to qualify for the lowest rate, you must have a responsible financial history and meet other conditions. Your actual rate will be within the range of rates listed above and will depend on a variety of factors, including evaluation of your credit worthiness, years of professional experience, income and other factors. See <a href='https://www.sofi.com/personal-loans/personal-loan-rates/' target='_blank'>APR examples and terms</a>. Interest rates on variable rate loans are capped at 14.95%. Lowest variable rate of 5.74% APR assumes current 1-month LIBOR rate of 2.49% plus 4.28% margin minus 0.25% AutoPay discount. For the SoFi variable rate loan, the 1-month LIBOR index will adjust monthly and the loan payment will be re-amortized and may change monthly. APRs for variable rate loans may increase after origination if the LIBOR index increases. The SoFi 0.25% AutoPay interest rate reduction requires you to agree to make monthly principal and interest payments by an automatic monthly deduction from a savings or checking account. The benefit will discontinue and be lost for periods in which you do not pay by automatic deduction from a savings or checking account.",
                    companyUuid: "66666666-6666-6666-6666-666666666666"
                },
                minApr: 8.2,
                uuid: "44444444-4444-4444-4444-444444444444",
                feeRate: null,
                productSubType: "personal_loan",
                minFeeRate: null,
                maxApr: 17.67,
                monthlyPayment: 203.73,
                terms: null,
                recommendationScore: 10,
                maxMonthlyPayment: 252.15,
                originatorId: null,
                maxAmount: 100000,
                allowPrepayment: true,
                termUnit: "month",
                productType: "loan",
                coApplicant: false,
                preQualified: false,
                sponsored: false,
                url: "https://www.sofi.com/homepage/",
                meanApr: 12.935,
                minFeeFixed: null,
                aprType: "fixed",
                termLength: 60,
                meanTotalPayment: 13632,
                preApproved: false,
                minTotalPayment: 12224,
                maxTotalPayment: 15129,
                feeFixed: null,
                secured: false,
                meanMonthlyPayment: 227.2
            }
        ],
        mortgageOffers: [],
        savingsOffers: [],
        specialOffers: [],
        pendingOriginators: [
          {
              key: "upgrade",
              name: "Upgrade",
              images: [
                  {
                      sizeKey: "120x40",
                      url: "https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png"
                  }
              ],
              companyUuid: "77777777-7777-7777-7777-777777777777"
          }
        ],
        pendingResponses: [
            {
                partner: {
                  uuid: "55555555-5555-5555-5555-555555555555",
                  name: "Upgrade",
                  description: "All loans through Upgrade feature fast funding, low fixed rates that will never increase, and an easy online interface to manage your loan.",
                  disclaimer: "Personal loans made through Upgrade feature APRs of 6.98%-35.89%. All personal loans have a 1.5% to 6% origination fee, which is deducted from the loan proceeds. Lowest rates require Autopay and paying off a portion of existing debt directly. For example, if you receive a $10,000 loan with a 36-month term and a 17.98% APR (which includes a 14.32% yearly interest rate and a 5% one-time origination fee), you would receive $9,500 in your account and would have a required monthly payment of $343.33. Over the life of the loan, your payments would total $12,359.97. The APR on your loan may be higher or lower and your loan offers may not have multiple term lengths available. Actual rate depends on credit score, credit usage history, loan term, and other factors. Late payments or subsequent charges and fees may increase the cost of your fixed rate loan. There is no fee or penalty for repaying a loan early. Personal loans issued by Upgrade's lending partners. Information on Upgrade's lending partners can be found at https://www.upgrade.com/lending-partners/.  ",
                  supportsPersonalizedOffers: true,
                  supportsPreSelect: false,
                  imageUrl: "https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80.png"
              },
              productTypes: [
                  "loan"
              ]
            }
        ]
      },
      toggleOffers: false,
      pendingOffers: false,
      pendingStep: 0
    }

    this.toggleOffersPage = this.toggleOffersPage.bind(this);
    this.toggleApplicationPage = this.toggleApplicationPage.bind(this);
    this.togglePendingOffers = this.togglePendingOffers.bind(this);
    this.pendingStepThrough = this.pendingStepThrough.bind(this);
  }

  private toggleOffersPage(){
      this.setState(prevState => ({
        toggleOffers: true
      }));
  }

  private toggleApplicationPage(){
    this.setState(prevState => ({
      toggleOffers: false
    }));
  }

  private onChangePersonalInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = "";
    
    if(field === 'dateOfBirth'){
      var year = event.getFullYear();
      var month = event.getMonth() + 1;
      var date = event.getDate();

      if(month > 0 && month < 10){
        month = "0" + month;
      }
      if(date > 0 && date < 10){
        date = "0" + date;
      }

      value = year + "-" + month + "-" + date;
    }
    else if(field === 'primaryPhone'){
      var str = event.target.value.replace(/[^\w\s]/gi, '');
      str = str.replace(/\s/g, '');
      value = str;
    }
    else{
      value = event.target.value;
    }

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        personalInformation: {
          ...prevState.requestJSON.personalInformation,
          [field]: value
        }
      }
    }));
  }

  private onChangeLoanInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = 0;

    if(field === 'loanAmount'){
      value = parseInt(event.target.value);
      if(isNaN(value)){
        value = 0;
      }
    }
    else{
      value = event.target.value;
    }

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        loanInformation: {
          ...prevState.requestJSON.loanInformation,
          [field]: value
        }
      }
    }));
  }

  private onChangeMortgageInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = event.target.value;

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        mortgageInformation: {
          ...prevState.requestJSON.mortgageInformation,
          [field]: value
        }
      }
    }));
  }
  
  private onChangeCreditInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = event.target.value;

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        creditInformation: {
          ...prevState.requestJSON.creditInformation,
          [field]: value
        }
      }
    }));
  }

  private onChangeFinancialInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = 0;

    if(field === 'annualIncome'){
      value = parseInt(event.target.value);
      if(isNaN(value)){
        value = 0;
      }
    }
    else{
      value = event.target.value;
    }

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        financialInformation: {
          ...prevState.requestJSON.financialInformation,
          [field]: value
        }
      }
    }));
  }

  private onChangeEducationInformation(fieldName:string, event: any){
    var field = fieldName;
    var value = event.target.value;

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        educationInformation: {
          ...prevState.requestJSON.educationInformation,
          [field]: value
        }
      }
    }));
  }

  private onChangeLegalInformation(event: any){
    var value = event.target.checked;

    this.setState(prevState =>({
      requestJSON: {
        ...prevState.requestJSON,
        legalInformation: {
          ...prevState.requestJSON.legalInformation,
          consentsToFcra: value,
          consentsToTcpa: value
        }
      }
    }));
  }

  private togglePendingOffers(){
    this.setState(prevState => ({
      pendingOffers: !prevState.pendingOffers
    }));
  }

  private onClickSubmitButton(event: any){
    this.togglePendingOffers();
    this.toggleOffersPage();
  }

  private pendingStepThrough(step: number){
    if(step > 3){
      step = 3;
    }
    else if(step < 0){
      step = 0;
    }

    this.setState(prevState => ({
      pendingOffers: false,
      pendingStep: step
    }));
  }

  public render(){
    var leftHalf = null;

    if(!this.state.toggleOffers){
      leftHalf = (
        <Form
          requestJson={this.state.requestJSON}
          personalInfomationOnChange={this.onChangePersonalInformation.bind(this)}
          loanInformationOnChange={this.onChangeLoanInformation.bind(this)}
          mortgageInformationOnChange={this.onChangeMortgageInformation.bind(this)}
          creditInformationOnChange={this.onChangeCreditInformation.bind(this)}
          financialInformationOnChange={this.onChangeFinancialInformation.bind(this)}
          educationInformationOnChange={this.onChangeEducationInformation.bind(this)}
          legalInformationOnChange={this.onChangeLegalInformation.bind(this)}
          tcpaLanguage={this.state.requestJSON.legalInformation.tcpaLanguage}
          submitButtonOnClick={this.onClickSubmitButton.bind(this)}
        />
      );
    }
    else{
      leftHalf = (
        <Offerwall 
          pendingOffers={this.state.pendingOffers} 
          offersJson={this.state.responseJSON} 
          toggleApplicationPage={this.toggleApplicationPage} 
          pendingStepThrough={this.pendingStepThrough}
          step1JSON={this.state.step1responseJSON}
          step2JSON={this.state.step2responseJSON}
          />
      );
    }

    return(
      <Router>
        <Switch>
          <Route exact path="/application">
            <div className="App">
              <div className="leftHalf">
                {leftHalf}
              </div>
              <div className="rightHalf">
              <JsonConsole
                displayOfferJSON={false}
                requestJson={this.state.requestJSON}
                productTypes={this.state.requestJSON.productTypes}
                responseJSON={this.state.responseJSON}
                pendingOffers={this.state.pendingOffers}
              />
              </div>
            </div>
          </Route>
          <Route exact path="/pending">
            <div className="App">
              <div className="leftHalf">
                <Offerwall 
                  pendingOffers={true}
                  offersJson={this.state.responseJSON}
                  step1JSON={this.state.step1responseJSON}
                  step2JSON={this.state.step2responseJSON}
                  toggleApplicationPage={this.toggleApplicationPage}
                  pendingStepThrough={this.pendingStepThrough}
                  step1={false}
                  step2={false}
                  step3={false}
                />
              </div>
              <div className="rightHalf">
                <JsonConsole
                  displayOfferJSON={true}
                  requestJson={this.state.requestJSON}
                  step1JSON={this.state.step1responseJSON}
                  step2JSON={this.state.step2responseJSON}
                  productTypes={this.state.requestJSON.productTypes}
                  responseJSON={this.state.responseJSON}
                  pendingOffers={true}
                  pendingStep={this.state.pendingStep}
                />
              </div>
            </div>
          </Route>
          <Route exact path="/offerwall">
            <div className="App">
              <div className="leftHalf">
                <Offerwall
                  pendingOffers={false}
                  offersJson={this.state.responseJSON}
                  toggleApplicationPage={this.toggleApplicationPage}
                  pendingStepThrough={this.pendingStepThrough}
                  step1JSON={this.state.step1responseJSON}
                  step2JSON={this.state.step2responseJSON}
                />
              </div>
              <div className="rightHalf">
              <JsonConsole
                displayOfferJSON={true}
                requestJson={this.state.requestJSON}
                productTypes={this.state.requestJSON.productTypes}
                responseJSON={this.state.responseJSON}
                pendingOffers={false}
              />
              </div>
            </div>
          </Route>
          <Route exact path="/*">
            <div className="welcomePage">
              <h1>Welcome to Even API Demo</h1>
              <p>The purpose of this demo is to gained a deeper understand on the functionality of the api.</p>
              <Button id="continueButton" href="/application"variant="contained" color="primary" >Continue</Button>
            </div>
          </Route>
        </Switch>
      </Router>
    );
  }
}
export default App;